import type ActiveSubscription from "types/ActiveSubscription";


export const STRIPE_SUBSCRIPTION_WRITES_UNAVAILABLE_MESSAGE = "Stripe subscription changes are currently unavailable.";

export function areStripeSubscriptionWritesUnavailable(
  activeSubscription?: Pick<ActiveSubscription, "billingProvider" | "capabilities"> | null
): boolean {
  return activeSubscription?.billingProvider === "stripe"
    && activeSubscription.capabilities.canWriteStripe === false;
}
